import { makeStyles } from "@material-ui/core";

// Width of the colour square and the HEX field (see view/components/ColorPicker).
const PICKER_WIDTH = 232;

export default makeStyles((theme) => ({
  // Floated like Quill's swatches: after `clear` the clearance swallows the
  // top margin.
  container: {
    float: "left",
    width: "100%",
    marginTop: theme.spacing(0.75),
    paddingTop: theme.spacing(0.25),
    borderTop: `1px solid ${theme.palette.separator.main}`,
  },
  // `!important` beats Quill's `.ql-snow.ql-toolbar button` sizing.
  button: {
    display: "flex !important",
    alignItems: "center",
    gap: theme.spacing(1),
    float: "none !important" as "none",
    width: "100% !important",
    height: "auto !important",
    padding: `${theme.spacing(0.25, 0)} !important`,
    fontSize: 14,
    color: `${theme.palette.tableRowTitle.main} !important`,
    whiteSpace: "nowrap",
    "& svg": {
      float: "none !important" as "none",
      width: 18,
      height: "18px !important",
    },
    // The editor strokes every toolbar icon path in the primary colour while
    // its picker is expanded; this icon is filled only.
    "&&& svg > path": {
      stroke: "none !important",
      fill: `${theme.palette.tableRowTitle.main} !important`,
    },
  },
  // Same surface as the Quill palette it replaces.
  paper: {
    padding: theme.spacing(2, 2, 1.25),
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.palette.otherElementsBackground.main,
    border: `1px solid ${theme.palette.separator.main}`,
    borderRadius: 0,
    boxShadow: "2px 4px 7px rgba(0, 0, 0, 0.12)",
    // react-colorful's root is 200x200px by default, which squeezes the square.
    "& .react-colorful": {
      width: PICKER_WIDTH,
      height: "auto",
    },
    // `[class*=…]`: the Exhibitor portal's class name generator suffixes MUI
    // global class names (`MuiTextField-root-123`).
    // Without the opacity field the HEX field takes the full picker width.
    "& [class*='MuiTextField-root']": {
      width: PICKER_WIDTH,
    },
    "& [class*='MuiOutlinedInput-root']": {
      boxShadow: "0 1px 2px rgba(31, 41, 55, 0.08)",
    },
    "& input": {
      textTransform: "uppercase",
      color: theme.palette.contrastText.main,
    },
    "& [class*='MuiOutlinedInput-notchedOutline']": {
      borderColor: theme.palette.separator.main,
    },
    "& [class*='MuiInputAdornment-root']": {
      color: theme.palette.contrastText.main,
    },
  },
  incomplete: {
    "&& input, && [class*='MuiInputAdornment-root']": {
      color: theme.palette.tableRowTitle.main,
    },
  },
  submit: {
    alignSelf: "flex-end",
    marginTop: theme.spacing(-0.75),
    padding: theme.spacing(0.75, 2),
  },
}));
